export function hasUnspacedSubstringLongerThan (text, maxCharsPerLine) {
  if (text.length <= maxCharsPerLine) {
    return false
  } else {
    const substringsDelimitedBySpace = text.split(' ')
    return substringsDelimitedBySpace.some(substring => substring.length > maxCharsPerLine)
  }
}

/* PdfMake never breaks words. It only breaks text at whitespace.
This function prevents long lines from pushing other content off the page. */
export function wrapTextAtMaxCharacters (text, maxCharsPerLine) {
  if (text.length <= maxCharsPerLine) {
    return text
  } else {
    const substringsDelimitedBySpace = text.split(' ')
    return substringsDelimitedBySpace.map(substring => {
      if (substring.length <= maxCharsPerLine) {
        return substring
      }
      return wrapSubstring(substring, maxCharsPerLine)
    }).join(' ')
  }
}

const charactersToSpace = ['.', ',', ':', ';', '!', '?', '_', ')', '&', '%']
function isSpaceable (char, followingChar) {
  switch (char) {
    case '.': return isNaN(followingChar)
    default: return charactersToSpace.includes(char)
  }
}

const regexDetectSpaceableCharacters = new RegExp(`[${charactersToSpace.map(c => `\\${c}`).join('')}]`, 'g')
const regexDetectGroupedSpaceableCharacters = new RegExp(`[${charactersToSpace.map(c => `\\${c}`).join('')}]{2,}`, 'g')

function wrapSubstring (substring, maxCharsPerLine) {
  const hasSpaceableCharacters = substring.match(regexDetectSpaceableCharacters) !== null
  const spaceableCharactersAreNotGrouped = substring.match(regexDetectGroupedSpaceableCharacters) === null

  const useSmartWrapping = hasSpaceableCharacters && spaceableCharactersAreNotGrouped

  if (useSmartWrapping) {
    return wrapSubstringByPunctuation(substring, maxCharsPerLine)
  } else {
    return wrapSubstringSimple(substring, maxCharsPerLine)
  }
}

function wrapSubstringByPunctuation (substring, maxCharsPerLine) {
  const substringAsArray = substring.split('')
  const spacedArray = wrapSubstringByPunctuationRecursive(substringAsArray, maxCharsPerLine, maxCharsPerLine)
  return spacedArray.join('')
}

function wrapSubstringByPunctuationRecursive (substringAsArray, startIndex, maxChars) {
  if (startIndex >= substringAsArray.length || startIndex <= 0) {
    return substringAsArray
  } else {
    const endRecursion = startIndex === substringAsArray.length - 1
    for (let i = startIndex; i >= startIndex - maxChars && i > 0; i--) {
      if (isSpaceable(substringAsArray[i], substringAsArray[i + 1]) && i !== substringAsArray.length - 1 && i !== 0) {
        const result = substringAsArray.toSpliced(i + 1, 0, '\n')
        const newStartIndex = i + 1 + maxChars
        return endRecursion ? result : wrapSubstringByPunctuationRecursive(result, newStartIndex, maxChars)
      }
    }
    if (endRecursion) return substringAsArray
    const result = substringAsArray.toSpliced(startIndex, 0, '\n')
    const newStartIndex = Math.min(startIndex + maxChars + 1, substringAsArray.length)
    return wrapSubstringByPunctuationRecursive(result, newStartIndex, maxChars)
  }
}

function wrapSubstringSimple (substring, maxCharsPerLine) {
  const regexMatchAllSubstringsMaxCharsOrFewer = new RegExp(`\\S{1,${maxCharsPerLine}}`, 'g')
  return substring.match(regexMatchAllSubstringsMaxCharsOrFewer).join('\n')
}
